// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__qxUNx","closeButton":"styles_closeButton__FFp10","bannerImage":"styles_bannerImage__9Oqjb","bannerText":"styles_bannerText__F3LY3"};